import type { FC } from 'react'

import { Textarea } from '@skytech/ui'
import { getWhiteLabelForDealerStyle } from '@skytech/utils'
import dayjs from 'dayjs'
import { useDispatch, useSelector } from 'react-redux'

import { useAppContext } from '@/App.context'
import Button from '@/components/form/Button'
import Input from '@/components/form/Input'
import { Translation } from '@/components/i18n/Translation'
import {
  getEcomOrderDeliveryDate,
  getEcomOrderDealerComment,
  getIsLoading,
  saveEcomOrder,
  setDealerComment,
  setInternalComment,
  setDeliveryDate,
  getEcomOrderInternalComment,
  getEcomOrderStatus,
  getEcomOrderVendorSalesNo,
  setVendorSalesOrderNo,
  getIsLockedForEditing,
} from '@/ducks/ecomOrderReducer'

import { EDITABLE_STATUSES, COMMENT_EDITABLE_STATUSES } from './constants'

const EcomOrderInputs: FC<{ isViewOnlyMode: boolean }> = ({ isViewOnlyMode }) => {
  const { whiteLabel } = useAppContext()
  const dispatch = useDispatch()
  const isPending = useSelector(getIsLoading)
  const status = useSelector(getEcomOrderStatus)
  const deliveryDate = useSelector(getEcomOrderDeliveryDate)
  const vendorSalesOrderNo = useSelector(getEcomOrderVendorSalesNo)
  const dealerComment = useSelector(getEcomOrderDealerComment)
  const internalComment = useSelector(getEcomOrderInternalComment)
  const isEditable = EDITABLE_STATUSES.includes(status)
  const isLockedForEditing = useSelector(getIsLockedForEditing)
  const isDisabled = isViewOnlyMode || isLockedForEditing || (!isEditable && !isPending)
  const isCommentEditable = COMMENT_EDITABLE_STATUSES.includes(status)

  // @ts-ignore
  const submit = e => {
    e.preventDefault()
    // @ts-ignore
    dispatch(saveEcomOrder())
  }

  return (
    <section className="ecom-order-inputs">
      <h3>
        <Translation id="Notes" />
      </h3>

      <form onSubmit={submit}>
        <div>
          <Input
            type="date"
            value={deliveryDate ? dayjs(deliveryDate).format('YYYY-MM-DD') : ''}
            onChange={e => dispatch(setDeliveryDate(e.target.value))}
            disabled={isDisabled}
            label={<Translation id="Delivery date" />}
            min={dayjs().format('YYYY-MM-DD')}
          />
        </div>

        <div>
          <Input
            value={vendorSalesOrderNo || ''}
            onChange={e => dispatch(setVendorSalesOrderNo(e.target.value))}
            disabled={isDisabled}
            label={<Translation id="Order number internal" />}
          />
        </div>

        <div>
          <Textarea
            id="dealer-comment"
            value={dealerComment || ''}
            onChange={e => dispatch(setDealerComment(e.target.value))}
            isDisabled={!isCommentEditable && !isEditable && !isPending}
            label={<Translation id="Your comment" />}
            whiteLabel={getWhiteLabelForDealerStyle(whiteLabel)}
          />
        </div>

        <div>
          <Textarea
            id="internal-comment"
            value={internalComment || ''}
            onChange={e => dispatch(setInternalComment(e.target.value))}
            isDisabled={!isCommentEditable && !isEditable && !isPending}
            label={<Translation id="Your comment (internal)" />}
            whiteLabel={getWhiteLabelForDealerStyle(whiteLabel)}
          />
        </div>

        <div>
          <Button disabled={!isCommentEditable && !isEditable && !isPending}>
            <Translation id="Update order" />
          </Button>
        </div>
      </form>
    </section>
  )
}

export default EcomOrderInputs
